<template>
    <div class="card">
        <div class="card-header">Update Date of Birth</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12" lg="4">
                    <BaseDateOfBirthInput v-model="application.license.dateOfBirth"
                                          :v="$v.application.license.dateOfBirth"
                                          label="Date of Birth"
                                          slug="dateOfBirth"
                                          setId="licDOB"
                                          :messages="dobMessages"/>
                </b-col>
                <b-col cols="12" lg="2" class="mt-2r">
                    <button class="btn btn-secondary" @click="onSubmit">
                        Update
                    </button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators'
    import minDate from '@/validators/minDate'
    import maxDate from '@/validators/maxDate'
    import moment from 'moment'
    import axiosRetry from 'axios-retry'
    import axios from 'axios'

    const maxDateOfBirthMoment = moment().subtract(18, 'years')
    const maxDateOfBirth = maxDateOfBirthMoment.toDate()

    export default {
        props: {
            application: {
                type: Object,
                default() {
                    return {
                        license: {
                            dateOfBirth: null
                        }
                    }
                }
            }
        },
        data: () => {
            return {
                dobMessages: {
                    maxDate: 'Applicants must be at least 18 years old.',
                    minDate: 'Birth Date after 01/01/1900.'
                },
            }
        },
        validations(){
            return {
                application: {
                    license:{
                        dateOfBirth: { required,
                            maxDate: maxDate(maxDateOfBirth),
                            minDate: minDate(new Date('1900-01-01')) }
                    }
                },
                form:['application']
            }
        },
        methods:{
            validate(){
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', 'd', this.$data,isValid)
                return isValid
            },
            onSubmit(){
                this.application.mnSupervisor = null
                this.application.prevMnSupervisor = null
                this.validate()
                if(!this.$v.form.$invalid){
                    var submitting = Object.assign({}, this.application, this.$data)
                    axiosRetry(axios,{retries:0})
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/contact/dob/`+this.application.applicationId,submitting)
                        .then(response => {
                            this.showRootToast("Date of Birth Updates","The DOB has been updated","success")
                        }).catch(error=>{
                        console.log(error)
                        this.showRootToast("Error","An error has occurred","danger")
                    })
                }
            },
            showRootToast(title, message, type){
                this.$root.$bvToast.toast(message,{
                    title: title,
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: type,
                    appendToast: true,
                    noAutoHide: true
                })
                this.toastFocus()
            },
            toastFocus(){
                setTimeout(() => {
                    let elem = document.getElementsByClassName("toast")
                    elem=elem[elem.length-1]
                    elem.focus()
                }, 100)
            },
        },
    }
</script>